export default "__VITE_ASSET__6f4fb953__"